export function deleteProduct(data) {
    let { deleteProductRequest, deleteProductError, deleteProductResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/product/delete',
        this.createBundle('app/product/delete', { product: data }, this.POST, deleteProductRequest, deleteProductResult, deleteProductError)
    )
}
